import { BButtonGroup } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBButtonGroup = createEgBootstrapProxy(
  "EgBButtonGroup",
  BButtonGroup
);
